import React from 'react'
import {marked} from 'marked'
import Spinner from '../../Spinner';
import ChatGraph from '../../ChatGraph';
import ProcessBar from '../../ProcessBar';

const DashboardUtterance = ({userMessage, response, agents=[], graphData=[]}) => {
    return (
        <>
            <div className='dashboard-user-message-display'>{userMessage}</div>
            {/* {showSpinner ? <Spinner /> : null} */}
            {agents.length > 0 ? <div className='dashboard-process-bar'>
                <ProcessBar agents={agents} />
            </div>
            : null }
            <div className='dashboard-response-display'>
                <p dangerouslySetInnerHTML={{ __html: marked(response) }}></p>
                {graphData.length > 0 && <ChatGraph graphs={graphData} />}
            </div>
        </>
    )
    
}

export default DashboardUtterance